import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { PureInput as Input } from '@alfa-bank/site-pure-input';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';

import type { TFormHiddenInput, IDeps } from './models';
import { FormHiddenInput as Component } from './form-hidden-input';

export const FormHiddenInput = createWidget<IDeps, TFormHiddenInput>({
    Field,
    Input,
})(Component);
